var map = {
	"./ALSHABAB.svg": "706d",
	"./Al-Hilal.svg": "d079",
	"./R8Soon.svg": "a76e",
	"./ZainKSA.svg": "2cf8",
	"./gcon.svg": "f768",
	"./playheraLogo.png": "634f",
	"./teamFalcons.svg": "eb3e",
	"./zainEsports.webp": "7005"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7c7";